/**
 * 客户端错误弹框工具
 * 用于在客户端连接失败时显示错误弹框
 */
import Vue from 'vue'

/**
 * 显示客户端错误弹框
 * 通过 Vue 事件总线触发 ClientErrorDialog 组件显示
 */
export function showClientErrorDialog() {
  // 使用项目的全局事件总线 $EventBus
  if (Vue.prototype.$EventBus) {
    Vue.prototype.$EventBus.$emit('showClientErrorDialog')
  }
}

/**
 * 处理客户端连接错误
 * 显示弹框替代原来的文字提示
 */
export function handleClientError() {
  showClientErrorDialog()
}



// WEBPACK FOOTER //
// ./src/assets/js/clientErrorDialog.js